var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookAds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    fillRule: "evenodd",
    d: "M44,24.1222268 C44,13.0090196 35.0457031,4 24,4 C12.9542969,4 4,13.0090196 4,24.1222268 C4,34.1658119 11.3137109,42.49044 20.875,44 L20.875,29.938808 L15.796875,29.938808 L15.796875,24.1222268 L20.875,24.1222268 L20.875,19.6890487 C20.875,14.6459156 23.8608594,11.8602448 28.4292969,11.8602448 C30.6174609,11.8602448 32.90625,12.2532571 32.90625,12.2532571 L32.90625,17.2052113 L30.3842969,17.2052113 C27.8998047,17.2052113 27.125,18.7563128 27.125,20.3476193 L27.125,24.1222268 L32.671875,24.1222268 L31.7851563,29.938808 L27.125,29.938808 L27.125,44 C36.6862891,42.49044 44,34.1658119 44,24.1222268"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookAds);
export default __webpack_public_path__ + "static/media/Facebook_Ads.fb6f2b37.svg";
export { ForwardRef as ReactComponent };